var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDisplay)?_c('div',{staticClass:"icon-wrapper",class:_vm.className},[_c('v-icon',[_vm._v("fas fa-dolly-flatbed")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }